











import { Component, Mixins } from "vue-property-decorator";
import { Auth } from "@/mixins/auth";
import { User } from "@/models/user/user";

@Component
export default class ImpersonationBanner extends Mixins(Auth) {
  async leaveImpersonation(): Promise<void> {
    const leaveUrl = this.impersonation?.leave_url;

    // Clear all app state so the next impersonation starts fresh
    await this.setAuthToken(null);
    await this.setLoggedIn(false);
    await this.setUserRole(null);
    await this.setImpersonation(null);
    await this.setUserInfo({} as User);

    if (leaveUrl) {
      window.location.href = leaveUrl;
    }
  }
}
